app.controller("EditPermissionController", ["$scope", "$uibModalInstance", "permission", "Access",
    function ($scope, $uibModalInstance, permission, Access) {
        //todo: fetch permission from api
        $scope.permission = permission;
        $scope.permissionName = permission.name;

        $scope.update = function () {
            if (!($scope.permission.name.length && $scope.permission.description.length)) {
                return;
            }
            Access.updatePermission($scope.permission).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);